<template>
  <section class="section" id="bags-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <!-- @get-operators="getOperators" -->
      <totems-title @get-totems="getTotems" />

      <totems-table :totems="totems" />
      <!-- <bags-table :bags="bags" @edit-bag="editBag" @qrcode-click="openQRCodeModal" @delete-bag="deleteBagModal" /> -->
    </div>
  </section>
</template>

<script>
import { common } from "../../mixins/common";
import { mapGetters } from "vuex";
import totemsTitle from "./TotemsTitle";
import TotemsTable from "./TotemsTable";

export default {
  mixins: [common],

  components: {
    totemsTitle,
    TotemsTable
  },

  data() {
    return {
      isLoading: false,
      totems: []
    };
  },

  methods: {
    getTotems() {
      // this.isLoading = true;
      // this.$store
      //   .dispatch("getBags", { storeId: this.storeBeingManaged._id })
      //   .then((res) => {
      //     if (res.data.result === "ok") {
      //       this.storeBeingManaged.bags = res.data.payload.bags;
      //     } else {
      //       this.alertError(res.data);
      //     }
      //   })
      //   .catch(() => {
      //     this.alertError({ message: "UNEXPECTED_ERROR" });
      //   })
      //   .finally(() => {
      //     this.isLoading = false;
      //   });
    }
  },

  computed: {
    ...mapGetters(["storeBeingManaged"])
  },

  mounted() {
    if (
      this.storeBeingManaged.totems &&
      Array.isArray(this.storeBeingManaged.totems)
    ) {
      this.totems = JSON.parse(JSON.stringify(this.storeBeingManaged.totems));
    }
  }
};
</script>

<style scoped>
#bags-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
